// components/INEPhoto.jsx
import { useState } from "react";
import { Image, Modal } from "react-bootstrap";

export default function INEPhoto({
                                     url,                       // <-- pasa selected?.ine_url
                                     title = "Foto INE",
                                     maxWidth = 500,
                                     height = 400,
                                     rounded = true,
                                     zoomable = true,          // click para ver en grande
                                     emptyText = "INE",
                                     className = "",
                                 }) {
    const [open, setOpen] = useState(false);

    return (
        <div className={className}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>{title}:</div>

            {url ? (
                <div style={{ width: "100%", maxWidth, margin: "0 auto", textAlign: "center" }}>
                    <Image
                        src={url}
                        alt="INE"
                        fluid
                        rounded={rounded}
                        style={{
                            width: "100%",
                            height,
                            objectFit: "contain",
                            borderRadius: rounded ? 4 : 0,
                            cursor: zoomable ? "zoom-in" : "default",
                        }}
                        onClick={() => zoomable && setOpen(true)}
                    />
                </div>
            ) : (
                <div
                    style={{
                        textAlign: "center",
                        padding: "60px 0",
                        color: "#6c757d",
                        fontStyle: "italic",
                    }}
                >
                    {emptyText}
                </div>
            )}

            {zoomable && url && (
                <Modal show={open} onHide={() => setOpen(false)} size="lg" centered>
                    <Modal.Body className="p-2">
                        <Image
                            src={url}
                            alt="INE ampliada"
                            fluid
                            style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
                        />
                    </Modal.Body>
                </Modal>
            )}
        </div>
    );
}
